import React, { useEffect } from "react";
import LetsPlay from "./LetsPlay/Content.tsx";

function LetPlay() {
  return (
    <>
      <LetsPlay />
    </>
  );
}

export default LetPlay;
